import type { Property } from 'csstype';
import type { ImageProps } from 'next/image';
import type { JSX, ReactNode } from 'react';

import Image from '../NextImage';
import { Wrapper } from './styles';

/**
 * Displays a Background Image
 */
function FullscreenBackground({
	src,
	className,
	objectPosition,
	objectFit = 'cover',
}: {
	src: ImageProps['src'];
	className?: string;
	children?: ReactNode;
	objectPosition?: Property.ObjectPosition<string | number>;
	objectFit?: Property.ObjectFit;
}): JSX.Element {
	return (
		<Wrapper className={className}>
			<Image src={src} alt="" fill style={{ objectFit, objectPosition }} />
		</Wrapper>
	);
}

export default FullscreenBackground;
